<template>
<div class="noMoreContent" :class="extClass" id="noMoreContent">
    <div class="tips" v-text="tips"></div>
</div>
</template>
<script>
export default {
    name: 'NoMore',
    props: {
        extClass: {
            type: String,
            default: '',
        },
        tips: {
            type: String,
            default: '全部加载完毕',
        },
    },
};
</script>
<style scoped lang="scss">
.noMoreContent {
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
}

.tips {
    width: 100%;
    color: #aaaaaa;
    height: 6rem;
    line-height: 4rem;
    font-size: 12px;
    text-align: center;
}
</style>
